// extracted by mini-css-extract-plugin
export default {"EmojiPicker":"Emoji_EmojiPicker__VqXRc","EmojiPopUp":"Emoji_EmojiPopUp__ApJBk","IconContainer":"Emoji_IconContainer__qLWky"};